/**
 * 生产环境尽力限制打开开发者工具（无法 100% 阻止，仅增加普通用户误触成本）
 */
export function applyDevToolsLock() {
  document.addEventListener('contextmenu', function (e) {
    e.preventDefault()
  })

  document.addEventListener(
    'keydown',
    function (e) {
      const k = e.key
      if (k === 'F12') {
        e.preventDefault()
        return
      }
      if (e.ctrlKey && k === 'u') {
        e.preventDefault()
        return
      }
      if (e.ctrlKey && e.shiftKey) {
        const c = k.length === 1 ? k.toLowerCase() : k
        if (c === 'i' || c === 'j' || c === 'c') {
          e.preventDefault()
        }
      }
    },
    true
  )
}
